import { BaseModel } from "@/models/base/BaseModel";
import { MaintenanceForm } from "@/models/maintenance/MaintenanceForm";
import {MaintenanceChecklist} from "@/models/maintenance/MaintenanceChecklist";
import {MaintenanceMedia} from "@/models/maintenance/MaintenanceMedia";

export class MaintenanceRequest extends BaseModel {
  DateTime: Date;
  dateTime: Date;
  additionalResponse: string;
  category: string;
  categoryId: string;
  completedDateTime: Date;
  friendlyText: string;
  icon: string;
  location: string;
  locationId?: string;
  residentId: string;
  residentName: string;
  status: string;
  vendor?: string;
  vendorId?: string;
  vendorEmail?: string;
  assignee?: string;
  assigneeId?: string;
  assigneeEmail?: string;
  assigneePhoneNumber?: string;
  cadence?: string;
  wingId?: string;
  department?: string;
  description?: string;
  name?: string;
  roomId?: string;
  roomName?: string;
  comment?: string;
  priority?: string;
  isSendEmailToVendor?: boolean;
  typeId?: string;
  createdByStaffId?: string;
  createdByStaffName?: string;
  isHazardous: boolean;
  hazardousDetails: string;
  risk: string;
  riskDetails: string;
  maintenanceType: string;
  forms: MaintenanceForm[];
  checklist: MaintenanceChecklist[];
  media: MaintenanceMedia[];
  dueDate?: string;

  constructor() {
    super();
    this.dateTime = null;
    this.dueDate = null;
    this.additionalResponse = "";
    this.category = "";
    this.categoryId = "";
    this.friendlyText = "";
    this.icon = "";
    this.location = "";
    this.locationId = "";
    this.residentId = "";
    this.residentName = "";
    this.status = "";
    this.vendor = "";
    this.vendorId = "";
    this.vendorEmail = "";
    this.assignee = "";
    this.assigneeId = "";
    this.assigneeEmail = "";
    this.assigneePhoneNumber = "";
    this.cadence = "";
    this.wingId = "";
    this.department = "";
    this.description = "";
    this.name = "";
    this.roomId = "";
    this.roomName = "";
    this.comment = "";
    this.priority = "";
    this.isSendEmailToVendor = false;
    this.typeId = "";
    this.createdByStaffId = "";
    this.createdByStaffName = "";
    this.isHazardous = false;
    this.hazardousDetails = "";
    this.risk = "";
    this.riskDetails = "";
    this.maintenanceType = "";
    this.forms = [];
    this.checklist = [];
    this.media = [];
  }
}
